import ProfileRequestCard from "./ProfileRequestCard";

const DenayRequest = () => {
  return (
    <div className="flex flex-col justify-start items-center w-full overflow-x-hidden">
      <ProfileRequestCard RejectHide={true} />
      <ProfileRequestCard RejectHide={true} />
      <ProfileRequestCard RejectHide={true} />
      <ProfileRequestCard RejectHide={true} />
      <ProfileRequestCard RejectHide={true} />
      <ProfileRequestCard RejectHide={true} />
    </div>
  );
};
export default DenayRequest;
